export { unstable_generateUtilityClasses as default } from '@mui/utils';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/generateUtilityClasses/index.js
// module id = 1991
// module chunks = 25